<template>
  <span class="badge">
    <vs-chip class="pt-0 pb-0 pr-2 pl-2" :color="context" v-text="content"></vs-chip>
  </span>
</template>

<script>
export default {
  name: 'BadgeStatus',
  props: {
    content: {
      type: String,
      required: true
    },
    status: {
      type: Number,
      required: true
    }
  },
  computed: {
    context () {
      switch (this.status) {
      case 1:
        return 'warning'
      case 2:
        return 'primary'
      case 3:
        return 'success'
      case 4:
        return 'danger'
      default:
        return ''
      }
    }
  }
}
</script>

<style scoped>

</style>
